import { createContext, PropsWithChildren, useEffect, useMemo, useState } from 'react'

import { useTransitionStore } from '../transition'
import Theme, { ThemeProps } from './theme'

export type ThemeVariant = 'light' | 'dark'

export type Context = ThemeProps & {
  theme: {
    header: ThemeVariant
    layout: ThemeVariant
    footer: ThemeVariant
  }
}

export const ThemeContext = createContext<Context | undefined>(undefined)

const ThemeProvider = ({ children, theme: wpTheme, fluid = false }: PropsWithChildren<Context>) => {
  const [theme, setTheme] = useState(wpTheme)
  const contextValue = useMemo(() => ({ fluid, theme }), [fluid, theme])

  useEffect(() => {
    const unsubscribe = useTransitionStore.subscribe(
      (state) => state.reveal,
      (reveal) => reveal && setTheme(wpTheme)
    )

    return () => {
      unsubscribe()
    }
  }, [wpTheme])

  return (
    <ThemeContext.Provider value={contextValue}>
      <Theme fluid={fluid} />
      {children}
    </ThemeContext.Provider>
  )
}

export default ThemeProvider
